import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Store will be injected later to avoid circular dependency
let store = null

export const injectStore = (_store) => {
  store = _store
}

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (store) {
      const token = store.getState().auth.accessToken
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } else {
      // Fallback to localStorage if store not injected yet
      const token = localStorage.getItem('accessToken')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // If error is 401 and we haven't tried to refresh token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      try {
        if (store) {
          const { refreshToken } = await import('@/store/slices/authSlice')
          await store.dispatch(refreshToken())
          return api(originalRequest)
        } else {
          // No store available, redirect to login
          window.location.href = '/login'
          return Promise.reject(error)
        }
      } catch (refreshError) {
        if (store) {
          const { clearCredentials } = await import('@/store/slices/authSlice')
          store.dispatch(clearCredentials())
        }
        window.location.href = '/login'
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default api
